import { useHistory, useLocation } from 'react-router-dom';

const PATHS = {
  ROLEPLAYS: '/roleplay',
};

const useRoleplayHelper = () => {
  const history = useHistory();
  const location = useLocation();

  const navigate = (pathname) =>
    history.push({
      pathname: pathname || PATHS.PLAYS,
      state: {
        prevPath: `${location.pathname}${location.search ? location.search : ''}`,
      },
    });

  return { navigate, PATHS };
};

export default useRoleplayHelper;
